import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=29f3190e&scoped=true"
import script from "./ContactEdit.vue?vue&type=script&lang=ts"
export * from "./ContactEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f3190e",
  null
  
)

export default component.exports